import { ReactNode, useEffect, useState } from "react";
import styles from "./style.module.css";
import AuthBackIconSvg from "../../components/icons/auth-back-icon";
import AuthCloseIconSvg from "../../components/icons/auth-close-icon";

const LOGO_SRC = `${process.env.PUBLIC_URL ?? ""}/logo-auth.svg`;

const LANDING_URL = "https://openwayvps.tech/";

interface LoginShellProps {
  children: ReactNode;
  onBack?: () => void;
  onClose?: () => void;
}

/**
 * Оболочка экранов входа.
 * - &lt;768px: сверху брендинг (свечение + лого), снизу карточка с формой.
 * - ≥768px: split — слева брендинг, справа панель с формой.
 */
function LoginShell({ children, onBack, onClose }: LoginShellProps) {
  const [open, setOpen] = useState(false);

  // По умолчанию крестик ведёт на лендинг — он присутствует на всех экранах входа.
  const handleClose =
    onClose ??
    (() => {
      window.location.href = LANDING_URL;
    });

  useEffect(() => {
    const frame = requestAnimationFrame(() => setOpen(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <div className={`${styles.screen} ${open ? styles.screenOpen : ""}`}>
      <div className={styles.brand} aria-hidden>
        <div className={styles.brandGlow} />
        <div className={styles.brandWordmark}>
          <img className={styles.brandLogo} src={LOGO_SRC} alt="OpenWay" />
        </div>
      </div>

      <div className={styles.pane}>
        {onBack && (
          <button
            type="button"
            className={styles.cornerBtn + " " + styles.cornerBtnBack}
            aria-label="Назад"
            onClick={onBack}
          >
            <AuthBackIconSvg />
          </button>
        )}
        <button
          type="button"
          className={styles.cornerBtn + " " + styles.cornerBtnClose}
          aria-label="Закрыть"
          onClick={handleClose}
        >
          <AuthCloseIconSvg />
        </button>
        <div className={styles.paneInner}>{children}</div>
        <div className={styles.legal}>
          Продолжая, вы подтверждаете свое согласие с{" "}
          <a className={styles.legalLink} href="/user-agreement" target="_blank" rel="noreferrer">
            Пользовательским соглашением
          </a>
          ,{" "}
          <a className={styles.legalLink} href="/privacy-policy" target="_blank" rel="noreferrer">
            Политикой конфиденциальности
          </a>{" "}
          и предоставляете{" "}
          <a className={styles.legalLink} href="/agreement" target="_blank" rel="noreferrer">Согласие</a>{" "}
          на обработку персональных данных.
        </div>
      </div>
    </div>
  );
}

export default LoginShell;
